import {Http, RequestOptions, URLSearchParams} from '@angular/http';
import {IDataFilter} from '../../services/DataTable';
import {Observable} from 'rxjs/Rx';
import {ListResponseModel} from '../response/response.model';
import {Injectable} from '@angular/core';
import {ProcessorsModel} from './processors.model';

@Injectable()
export class ProcessorsService {

    private API_ROOT: string = '/processors';

    constructor(private http: Http) {
    }

    getList(filter?: IDataFilter): Observable<ListResponseModel<ProcessorsModel>> {
        let params: URLSearchParams = new URLSearchParams();
        if (filter) {
            for (let key in filter) {
                params.set(key, filter[key]);
            }
        }

        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getListByClient(clientId: number, filter?: IDataFilter): Observable<ListResponseModel<ProcessorsModel>> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/clients/${clientId}/processors`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

}


// WEBPACK FOOTER //
// ./src/app/models/processors/processors.service.ts